import api from "./api";

export const registrar = async (usuario) => {
  console.log("Sending data:", usuario);
  try {
    const response = await api.post("/usuario", usuario);
    return response.data;
  } catch (error) {
    console.error("Full error:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const login = async (credenciais) => {
  try {
    const response = await api.post("/usuario/login", credenciais);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  // Se houver outras informações do usuário no localStorage, remova aqui
  localStorage.removeItem("user");
  
  // Redefinir estado global ou cache, se necessário
  // Por exemplo, limpar o cache do Apollo Client, etc.
  
  return true;
};

export const adicionarMedicamento = async (medicamento) => {
  try {
    const response = await api.post("/medicamento", medicamento, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar medicamento:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const getMeusMedicamentos = async () => {
  try {
    const response = await api.get("/medicamento/meus-medicamentos");
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar medicamentos:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const atualizarMedicamento = async (id, data) => {
  try {
    const response = await api.put(`/medicamento/${id}`, data, {
      headers: { 
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro na requisição PUT:", {
      config: error.config,
      response: error.response?.data
    });
    throw error;
  }
};

export const deletarMedicamento = async (id) => {
  const response = await api.delete(`/medicamento/${id}`);
  return response.data;
};

export const getPerfilUsuario = async () => {
  try {
    const response = await api.get("/usuario/perfil", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar perfil do usuário:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const atualizarPerfilUsuario = async (id, data) => {
  try {
    const response = await api.put(`/usuario/${id}`, data, {
      headers: { 
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar perfil:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const alterarSenhaUsuario = async (id, { senhaAtual, novaSenha }) => {
  try {
    const response = await api.post(`/usuario/alterar-senha`, 
      { id, senhaAtual, novaSenha },
      {
        headers: { 
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao alterar senha:", error);
    throw error.response ? error.response.data : error.message;
  }
};

// Funções utilitárias para tokens/usuário
export const getToken = () => {
  return localStorage.getItem("token");
};

export const getUserId = () => {
  // Assumindo que o token JWT contém o ID do usuário
  // Em uma aplicação real, você pode querer decodificar o JWT para obter o ID
  const userInfo = getUser();
  return userInfo?.id;
};

export const getUser = () => {
  const userJson = localStorage.getItem("user");
  return userJson ? JSON.parse(userJson) : null;
};

// Métodos para Modelos de Medicamentos
export const getMeusModelosMedicamentos = async () => {
  try {
    const response = await api.get("/modelomedicamento", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar modelos de medicamentos:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const adicionarModeloMedicamento = async (modelo) => {
  try {
    const response = await api.post("/modelomedicamento", modelo, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar modelo de medicamento:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const atualizarModeloMedicamento = async (id, modelo) => {
  try {
    const response = await api.put(`/modelomedicamento/${id}`, modelo, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar modelo de medicamento:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export const deletarModeloMedicamento = async (id) => {
  try {
    await api.delete(`/modelomedicamento/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return true;
  } catch (error) {
    console.error("Erro ao deletar modelo de medicamento:", error);
    throw error.response ? error.response.data : error.message;
  }
};